export default async function auth ({ to, store }) {
  const authToken = store.state.authToken || await store.dispatch('loadAuthToken', null, { root: true })
  // TODO: maybe change file name / put this in other file
  const me = store.getters['users/me']
  if (me && (!me.sex || !me.firstname || !me.lastname || me.state === 'PENDING' )) {
    if (to.name === 'fill-user-details') return
    return { name: 'fill-user-details' }
  }

  const storeBranding = store.getters['schoolBranding/getBranding']
  const branding = to.query.branding || storeBranding

  if (authToken || to.name === 'login-start') return

  return { name: 'login-start', query: { branding } }
}
